import React from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import { object, func } from 'prop-types'
import { MobileWeekTable, WeekTable } from '../../components'
import { fetchAction } from '../../../../store/actions/fetchAction'

import styles from './WeeklyWorkoutPage.styl'

class WeeklyWorkoutPage extends React.Component {

	static propTypes = {
		fetchResults: object,
		dispatch: func
	}
	constructor(props) {
		super(props)
		const { dispatch } = props
		const date = moment.utc().startOf('week').add(1, 'days')
		this.fetchWeekByDate(date.valueOf(), dispatch)
		this.state = { date }
		this.handleChange = this.handleChange.bind(this)
	}
	fetchWeekByDate(date, dispatch) {
		dispatch(fetchAction(`/api/athletes/week/${ date }`, ['FETCH_QUERIES_START', 'FETCH_QUERIES_SUCCESS', 'FETCH_QUERIES_REJECT'], { fetchUrl: `week_${ date }` }))
	}
	handleChange(direction) {
		const { dispatch } = this.props
		this.setState(prevState => {
			const date = moment.utc(prevState['date'].valueOf()).add(direction, 'weeks')
			this.fetchWeekByDate(date.valueOf(), dispatch)
			return { date }
		})
	}
	render() {
		const { fetchResults } = this.props
		const { date } = this.state
		const week = fetchResults[`week_${ date.valueOf() }`]
		return (
			<div className={ styles['page'] }>
				<div className={ styles['content'] }>
					<div className={ styles['week-table'] }>
						<WeekTable
							date={ date }
							onChange={ this.handleChange }
							week={ week || {} }
						/>
					</div>
					<div className={ styles['mobile-week-table'] }>
						<MobileWeekTable
							date={ date }
							onChange={ this.handleChange }
							week={ week || {} }
						/>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	fetchResults: state.fetch.results
})

export default connect(mapStateToProps)(WeeklyWorkoutPage)



// WEBPACK FOOTER //
// ./src/client/webapp/pages/WeeklyWorkoutPage/WeeklyWorkoutPage.js